<template>
    <div class="temple-wrapper">
        <h3>Shadow Temple</h3>
        <div style="display: flex">
            <div class="temple" tabindex="0" oncontextmenu="return false;" v-on:mousedown="onMouseDown" v-on:keydown="onKeyPress">
                <table :key="shadowData.historyStep">
                    <tr v-for="n in 9" v-bind:key="n">
                        <td v-for="m in 9" v-bind:key="m" v-bind:class="{ 
                                'leftEdge': isLeftEdge(m),
                                'rightEdge': isRightEdge(m),
                                'topEdge': isTopEdge(n),
                                'bottomEdge': isBottomEdge(n),
                            }">
                            <SudokuCell :key="m+n" v-bind:col="m" v-bind:row="n" v-bind:removeObstacle="removeObstacle" v-bind:data="shadowData.sudokuHistory[shadowData.historyStep].cells[getIndex(m,n)]" />
                        </td>
                    </tr>
                </table>
            </div>
            <div class="shadow-controls">
                <button class="btn btn-sm btn-outline-secondary" v-on:click="toggleDigit(1)" v-text="shadowData.sudokuHistory[shadowData.historyStep].getCell(3, 1).isGiven ? 'Hide 1' : 'Show 1'" />
                <button class="btn btn-sm btn-outline-secondary" v-on:click="toggleDigit(2)" v-text="shadowData.sudokuHistory[shadowData.historyStep].getCell(4, 1).isGiven ? 'Hide 2' : 'Show 2'" />
                <button class="btn btn-sm btn-outline-secondary" v-on:click="toggleDigit(3)" v-text="shadowData.sudokuHistory[shadowData.historyStep].getCell(3, 3).isGiven ? 'Hide 3' : 'Show 3'" />
                <button class="btn btn-sm btn-outline-secondary" v-on:click="toggleDigit(4)" v-text="shadowData.sudokuHistory[shadowData.historyStep].getCell(7, 1).isGiven ? 'Hide 4' : 'Show 4'" />
                <button class="btn btn-sm btn-outline-secondary" v-on:click="toggleDigit(5)" v-text="shadowData.sudokuHistory[shadowData.historyStep].getCell(5, 1).isGiven ? 'Hide 5' : 'Show 5'" />
                <button class="btn btn-sm btn-outline-secondary" v-on:click="toggleDigit(6)" v-text="shadowData.sudokuHistory[shadowData.historyStep].getCell(2, 5).isGiven ? 'Hide 6' : 'Show 6'" />
                <button class="btn btn-sm btn-outline-secondary" v-on:click="toggleDigit(7)" v-text="shadowData.sudokuHistory[shadowData.historyStep].getCell(1, 4).isGiven ? 'Hide 7' : 'Show 7'" />
                <button class="btn btn-sm btn-outline-secondary" v-on:click="toggleDigit(8)" v-text="shadowData.sudokuHistory[shadowData.historyStep].getCell(3, 5).isGiven ? 'Hide 8' : 'Show 8'" />
                <button class="btn btn-sm btn-outline-secondary" v-on:click="toggleDigit(9)" v-text="shadowData.sudokuHistory[shadowData.historyStep].getCell(2, 1).isGiven ? 'Hide 9' : 'Show 9'" />
            </div>
        </div>
        <div class="notes card">
            <div class="card-header">
                Notes
            </div>
            <div class="card-body">
                <textarea v-model="shadowData.notes" style="width: 100%; height: 150px" />
            </div>
        </div>
    </div>
</template>

<script>
    import SudokuCell from './SudokuCell.vue';
    import { addOrRemoveInnerPencil, addOrRemoveOuterPencil, setAnswer, isAnswerSet, selectedCellsHaveData, clearCells } from '../presets/sudoku.js';
    import { deep_value } from '../presets/utilities.js'
    import _ from 'lodash';

    export default {
        name: 'shadow-temple',
        components: {
            SudokuCell
        },
        props: {
            shadowData: {
                type: Object,
                required: true
            },
            inventory: {
                type: Object,
                required: true
            },
            controls: {
                type: Object,
                required: true
            },
            saveData: {
                type: Function,
                required: true
            }
        },
        methods: {
            getCell: function(col, row) { return this.shadowData.sudokuHistory[this.shadowData.historyStep].getCell(col, row); },
            getIndex: function(col, row) { return (col-1) + 9*(row-1); },
            isLeftEdge: function(m) { return m == 4 || m == 7; },
            isRightEdge: function(m) { return m == 3 || m == 6; },
            isTopEdge: function(n) { return n == 4 || n == 7; },
            isBottomEdge: function(n) { return n == 3 || n == 6; },
            onMouseDown: function(event) {
                if(!event.shiftKey && !event.ctrlKey) {
                    this.shadowData.clearSelections();
                }
            },
            removeObstacle: function(m, n) {
                var data = this.shadowData.sudokuHistory[this.shadowData.historyStep];
                if(this.inventory.getItem(data.getCell(m, n).obstacle.item).acquired) {
                    var newData = _.cloneDeep(data);
                    newData.getCell(m, n).obstacle = null;
                    this.shadowData = this.shadowData.applyChanges(newData, this.awardPrize);
                }
            },
            /* eslint-disable no-unused-vars */
            awardPrize: function(key, region) {
                if (key.indexOf('.') == -1) {
                    var message = "You got " + key + "!";
                    var icon = '';
                    if (key.indexOf('Rupee') != -1) {
                        var num = Number(key.replace(/\D/g,''));
                        this.inventory.rupees += num;
                        icon = 'rupee.png';
                    } else if(key.indexOf('Gold Skulltula') != -1) {
                        this.inventory.goldSkulltulas += 1;
                        icon = 'gold-skulltula.png'
                    } else if(key.indexOf('Heart Piece') != -1) {
                        if(this.inventory.heartPieces == 3)
                        {
                            this.inventory.hearts += 1;
                            this.inventory.heartPieces = 0;
                        } else {
                            this.inventory.heartPieces += 1;
                        }
                        icon = 'heartPiece1.png'
                    }
                    this.controls.showItemDialog(icon, message);
                } else {
                    var item = deep_value(this.inventory, key);
                    item.acquired = true;
                    this.controls.showItemDialog(item.iconFileName, "You got " + item.name + "!");
                }
                if(this.shadowData.solvedRegions.length == 9) {
                    this.inventory.medallions.shadow.acquired = true;
                    if(this.inventory.checkMedallions()) {
                        this.controls.showVictory = true;
                        this.controls.itemDialog = false;
                    }
                }
                this.saveData();
            },
            toggleDigit: function(digit) {
                var data = this.shadowData.sudokuHistory[this.shadowData.historyStep];
                var newData = this.shadowData.toggleGivens(digit);
                this.shadowData = this.shadowData.applyChanges(newData, this.awardPrize);
            },
            onKeyPress: function(event) {
                var data = this.shadowData.sudokuHistory[this.shadowData.historyStep];
                var areCellsSelected = data.cells.filter(cell => cell.isSelected).length > 0;
                var newData;
                var digitPressed = 0;
                if(event.code == "Digit1" || event.code == "Numpad1")
                    digitPressed = 1;
                if(event.code == "Digit2" || event.code == "Numpad2")
                    digitPressed = 2;
                if(event.code == "Digit3" || event.code == "Numpad3")
                    digitPressed = 3;
                if(event.code == "Digit4" || event.code == "Numpad4")
                    digitPressed = 4;
                if(event.code == "Digit5" || event.code == "Numpad5")
                    digitPressed = 5;
                if(event.code == "Digit6" || event.code == "Numpad6")
                    digitPressed = 6;
                if(event.code == "Digit7" || event.code == "Numpad7")
                    digitPressed = 7;
                if(event.code == "Digit8" || event.code == "Numpad8")
                    digitPressed = 8;
                if(event.code == "Digit9" || event.code == "Numpad9")
                    digitPressed = 9;
                    
                if(digitPressed > 0) {
                    event.preventDefault();
                }

                /* eslint-disable no-undef */
                if(digitPressed > 0 && areCellsSelected) {
                    if (event.shiftKey || event.key.indexOf(digitPressed) == -1) {
                        if(this.controls.shiftAction == "innerPencil")
                            newData = addOrRemoveInnerPencil(data, digitPressed);
                        else if(this.controls.shiftAction == "outerPencil")
                            newData = addOrRemoveOuterPencil(data, digitPressed);
                        else if(this.controls.shiftAction == "answer" && !isAnswerSet(data, digitPressed))
                            newData = setAnswer(data, digitPressed);
                    } else if(event.altKey || macKeys.ctrlKey) {
                        if(this.controls.altAction == "innerPencil")
                            newData = addOrRemoveInnerPencil(data, digitPressed);
                        else if(this.controls.altAction == "outerPencil")
                            newData = addOrRemoveOuterPencil(data, digitPressed);
                        else if(this.controls.altAction == "answer" && !isAnswerSet(data, digitPressed))
                            newData = setAnswer(data, digitPressed);
                    } else {
                        if(this.controls.normalAction == "innerPencil")
                            newData = addOrRemoveInnerPencil(data, digitPressed);
                        else if(this.controls.normalAction == "outerPencil")
                            newData = addOrRemoveOuterPencil(data, digitPressed);
                        else if(this.controls.normalAction == "answer" && !isAnswerSet(data, digitPressed))
                            newData = setAnswer(data, digitPressed);
                    }
                } else if((event.code == "Delete" || event.code == "Backspace")) {
                    event.preventDefault();
                    if(selectedCellsHaveData(data)) {
                        newData = clearCells(data);
                    }
                }

                if(newData) {
                    this.shadowData = this.shadowData.applyChanges(newData, this.awardPrize);
                    this.saveData();
                }
            }
            
        }
    }
</script>

<style scoped>
    @media all and (max-width: 1670px) {
        .temple-wrapper {
            width: 600px; 
            margin-left: 5%;
        }
        table {
            width: 400px;
            height: 400px;
        }
        td {
            width: 45px;
            height: 45px;
        }
    }
    @media all and (min-width: 1671px) {
        .temple-wrapper {
            width: 600px; 
            margin-left:5%;
        }
        table {
            width: 585px;
            height: 585px;
        }
        td {
            height: 65px;
            width: 65px;
        }
    }
    .temple:focus {
        outline:none
    }
    table {
        background-image: url('../assets/images/shadow-medallion.png'), url('../assets/images/paper.png');
        background-size:cover, auto;
    }
    td {
        vertical-align: middle;
        padding: 0px;
        margin: 0px;
        border: 1px solid #b9b9b9;
    }
    .cell {
        vertical-align: middle;
    }
    .rightEdge {
        border-right: 2px solid gray;
    }
    .leftEdge {
        border-left: 2px solid gray;
    }
    .bottomEdge {
        border-bottom: 2px solid gray;
    }
    .topEdge {
        border-top: 2px solid gray;
    }
    .btn {
        margin: 5px;
        width: 125px;
    }
    .shadow-controls {
        margin-left: 30px;
    }
</style>